import { Auth } from 'aws-amplify'
import Messages from '@/helpers/message-helper'

export default {
	getCognitoSession: async () => {
		try {
			return await Auth.currentSession()
		} catch (error) {
			if (error !== 'No current user') Messages.showError(error)
			return false
		}
	},

	getCognitoUser: async () => {
		try {
			const user = await Auth.currentAuthenticatedUser()

			const { payload } = user.signInUserSession.accessToken
			if (!payload["cognito:groups"]) Messages.showError('User account has no access rights')

			return user
		} catch (error) {
			if (error !== 'No current user') Messages.showError(error)
			return false
		}
	},

	signOut: async () => {
		return await Auth.signOut()
	}
}